// extracted by mini-css-extract-plugin
export default {"range":"PieceRendererNoteChangeDuration_range__qt-Ie"};